<template>
  <span>
    <m-datatable :showExportBtns="false" :showSelect="false" :headers="headers" :apiUrl="url" :filters.sync="filters">
      <template #title-left>
        موجودی فعلی:
        <span class="mx-3">{{ balance || 0 | toMoney }}</span>
        ریال
      </template>
    </m-datatable>
  </span>
</template>

<script>
export default {
  props: {
    userId: {},
    balance: {},
  },
  data() {
    return {
      headers: [
        {
          text: "تاریخ",
          value: "datetime",
          getValue: (item) => {
            return item.datetime.split(" ")[0];
          },
        },
        {
          text: "ساعت",
          value: "date",
          filterable: false,
          sortable: false,
          getValue: (item) => {
            return item.datetime.split(" ")[1];
          },
        },
        {
          text: "توضیحات",
          value: "explanation",
        },
        {
          text: "بدهکار",
          value: "bed",
          type: "numeric",
          filterable: false,
          sortable: false,
        },
        {
          text: "بستانکار",
          value: "bes",
          type: "numeric",
          filterable: false,
          sortable: false,
        },
        // {
        //   text: "مانده",
        //   value: "remain",
        //   type: "numeric",
        //   filterable: false,
        //   sortable: false,
        // },
        {
          text: "فاکتور",
          value: "factor",
        },
        {
          text: "موفق",
          value: "_is_successful",
          type: "boolean",
        },
      ],
      filters: {
        user: null,
      },
      url: "sobhanAdmin/transactions",
    };
  },
  mounted() {
    this.filters.user = this.userId;
  },
  watch: {
    userId() {
      this.filters.user = this.userId;
    },
  },
};
</script>
